import { useQuery } from '@tanstack/react-query'
import { getLastViewedTopicId } from '@/features/topics/state/useActiveTopic'
import { fetchSources } from '@/features/sources/api/sourcesClient'
import type { Source } from '@/features/sources/model/contracts'

type GroupedSources = Record<string, Source[]>

export function useSettingsDatasourcesController() {
  const topicId = getLastViewedTopicId()

  const { data, isLoading, error } = useQuery({
    queryKey: ['sources', 'settings-datasources'],
    queryFn: ({ signal }) => fetchSources({ limit: 200, isEnabled: true }, signal),
  })

  const sources = data?.sources ?? []

  const grouped = sources.reduce<GroupedSources>((acc, source) => {
    const key = source.platform
    if (!acc[key]) acc[key] = []
    acc[key].push(source)
    return acc
  }, {})

  return {
    topicId,
    grouped,
    isLoading,
    error,
  }
}
